module.exports = __webpack_public_path__ + "static/img/chevron-down-black.130d057a.svg";